const question = {
    yes: { point: [3] },
    no: { point: [0] },
};

export default question;
